import type {
  IZindexLayer,
  IZindexLayers,
  IZIndexService,
  RicosSettingsStyles,
} from './../ricos-types';

const BASE_ZINDEX = {
  mobile: 100000, // due forum mobile dialog zindex
  desktop: 5000, //photo sutdio zindex - 6000, MM zindex - 10000
};

const zIndexLayers: IZindexLayers = {
  TOOLBAR: 100,
  POPUP: 200,
  DRAWER: 300,
  DIALOG: 300,
  TOOLTIP: 400,
  NOTIFICATION: 500,
};

export class ZIndexService implements IZIndexService {
  private baseZIndex: number;

  private settingsStyles: RicosSettingsStyles | undefined;

  constructor(isMobile: boolean, settingsStyles?: RicosSettingsStyles) {
    this.baseZIndex = isMobile ? BASE_ZINDEX.mobile : BASE_ZINDEX.desktop;
    this.settingsStyles = settingsStyles;
  }

  layerToCssVar(layer: IZindexLayer): string | undefined {
    if (!this.settingsStyles || !this.settingsStyles?.modals) {
      return undefined;
    }

    return `--ricos-settings-modals-${layer.toLowerCase()}-z-index`;
  }

  getZIndex(layer: IZindexLayer): string | number {
    const defaultValue = this.baseZIndex + zIndexLayers[layer];
    const themeLayerValue = this.layerToCssVar(layer);

    return themeLayerValue !== undefined
      ? `var(${themeLayerValue}, ${defaultValue})`
      : defaultValue;
  }
}
